<template>
    <PegasusHeading>Lezáratás adminisztráció</PegasusHeading>

    <div class="row">
        <div class="col-lg-6">
            <PegasusPanel header="Lezáratás típusok">
                <PegasusTable :data="types">
                    <Column field="name" header="Név"></Column>

                    <Column :field="item => item.price.huf()" header="Óradíj"></Column>

                    <Column :field="item => item.public ? 'Igen' : 'Nem'" header="Publikus"></Column>

                    <Column header="Műveletek">
                        <template #body="{data}: {data: ClosureType}">
                            <PegasusButton :params="{type: data}" to="events.admin.closures.type" variant="primary">
                                <i class="fa fa-edit"></i> Szerkesztés
                            </PegasusButton>
                        </template>
                    </Column>
                </PegasusTable>
            </PegasusPanel>
        </div>

        <div class="col-lg-6">
            <PegasusPanel header="Következő 30 nap lezáratásai">
                <PegasusTable :data="closures">
                    <Column field="name" header="Rendezvény" sortable>
                        <template #body="{data}: {data: Closure}">
                            <a href="javascript:void(0)" @click="dialog.open(ShortEventDialog, {eventData: events[data.event]})">{{ events[data.event].name }}</a>
                        </template>
                    </Column>

                    <Column :field="(closure: Closure) => types[closure.type].name" header="Lezáratás típus"></Column>

                    <Column field="hours" header="Hossz"></Column>

                    <Column :field="(closure: Closure) => closure.getPrice(types[closure.type]).huf()">
                        <template #header>
                            <span class="mx-1">Összeg</span>
                            <PegasusHelp title="Lezáratás költsége">
                                (Hossz órában + 2) * óradíj
                            </PegasusHelp>
                        </template>
                    </Column>

                    <Column field="" header="Műveletek">
                        <template #body="{data}">
                            <PegasusButton variant="primary" @click="openClosure(data)">
                                <i v-if="events[data.event].canEdit" class="fa fa-edit"></i>
                                <i v-else class="fa fa-eye"></i>
                            </PegasusButton>
                        </template>
                    </Column>

                </PegasusTable>
            </PegasusPanel>
        </div>
    </div>
</template>

<title>Rendezvények admin</title>

<script lang="ts" setup>
import {useAuthStore} from '@/stores/auth';
import PegasusButton from '@Components/base/PegasusButton.vue';
import PegasusHeading from '@Components/base/PegasusHeading.vue';
import PegasusHelp from '@Components/base/PegasusHelp.vue';
import PegasusPanel from '@Components/base/PegasusPanel.vue';
import PegasusTable from '@Components/base/table/PegasusTable.vue';
import ClosureDialog from '@Components/events/closures/ClosureDialog.vue';
import ShortEventDialog from '@Components/events/ShortEventDialog.vue';
import {Closure} from '@Models/events/Closure';
import {ClosureType} from '@Models/events/ClosureType';
import Event from '@Models/events/Event';
import {useDialog} from '@Utils/dialog';
import {each, map} from 'lodash-es';
import Column from 'primevue/column';

useAuthStore().requireUser();

const types = await ClosureType.getAll();

const closures = await Closure.getNext();

const events: Record<number, Event> = {};

await Promise.all(
    map(closures, closure => Event.getById(closure.event).then(event => events[event.id] = event)),
);

const maps: Record<number, string[]> = {};

each(types, type => {
    type.getMap().then(map => {
        maps[type.id] = map;
    });
});

const dialog = useDialog();

function openClosure(closure: Closure) {
    dialog.open(ClosureDialog, {closure, event: events[closure.event], maps});
}
</script>
